/**
 * INCENTIVE-TRACKER MODULE
 * Self-contained. Import only from /shared or within this module.
 *
 * Manager review step (pending_review). A manager (account owner/admin) approves
 * or rejects with an optional note. The DB enforces that only a manager can take
 * these edges; non-managers just see a waiting message.
 */
import { useState } from "react";

export default function ReviewPanel({ isManager, onApprove, onReject }) {
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  async function act(fn) {
    setBusy(true); setErr(null);
    try { await fn(note); }
    catch (e) { setErr(e.message); setBusy(false); }
  }

  if (!isManager) {
    return (
      <div className="it-note">
        This program is awaiting review by the Sales Manager (set in System Settings →
        Incentives). They — or a workspace owner/admin — approve it before it can be sent.
      </div>
    );
  }

  return (
    <div>
      <h2 style={{ marginTop: 0 }}>Sales Manager review</h2>
      <p className="muted">Approve to unlock sending, or reject to return it to draft for edits.</p>
      <label style={{ display: "block", fontSize: 13 }}>
        Review note <span className="muted">(optional — shared on the program)</span>
        <textarea rows={3} value={note} onChange={(e) => setNote(e.target.value)}
                  placeholder="Looks good / please adjust the case target…" />
      </label>
      {err && <p className="error" style={{ fontSize: 13 }}>{err}</p>}
      <div style={{ display: "flex", gap: 10, marginTop: 12 }}>
        <button className="btn" onClick={() => act(onApprove)} disabled={busy}>Approve</button>
        <button className="secondary danger" onClick={() => act(onReject)} disabled={busy}>Reject → back to draft</button>
      </div>
    </div>
  );
}
